import { render, staticRenderFns } from "./invoice-info.vue?vue&type=template&id=19f04435&scoped=true"
import script from "./invoice-info.vue?vue&type=script&lang=js"
export * from "./invoice-info.vue?vue&type=script&lang=js"
import style0 from "./invoice-info.vue?vue&type=style&index=0&id=19f04435&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f04435",
  null
  
)

export default component.exports